import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/Index'
import Landing from '@/views/Landing'
import Question from '@/views/Question/Index'
import Auth from '@/views/Auth/Index'
import SignUp from '@/views/Auth/SignUp'
import Login from '@/views/Auth/Login'
import Nominate from "@/views/Auth/Nominate"
import ForgotPin from "@/views/Auth/ForgotPin"
import Verify from "@/views/Auth/Verify"
import ResetMpin from "@/views/Auth/ResetMpin"
import ResetSuccess from "@/views/Auth/ResetSuccess"
import ThankYou from '@/views/ThankYou'
import NotAvailable from '@/views/NotAvailable.vue'
import NotFound from '@/views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    beforeEnter() {
      window.location.replace("https://www.rush.ph/");
    }
  },
  {
    path: '/:subdomain/:uuid',
    component: Index,
    props: true,
    children: [
      { path: '/', name: 'Landing', component: Landing },
      { path: 'questions', name: 'Question', component: Question },
      { path: 'thank-you', name: 'ThankYou', component: ThankYou },
      { path: 'not-available', name: 'NotAvailable', component: NotAvailable },
      {
        path: 'auth',
        component: Auth,
        redirect: {name: 'SignUp'},
        children: [
          { path: 'signup', name: 'SignUp', component: SignUp },
          { path: 'login', name: 'Login', component: Login },
          { path: 'nominate', name: 'Nominate', component: Nominate },
          { path: 'forgot-pin', name: 'ForgotPin', component: ForgotPin },
          { path: "verify", name: 'Verify', component: Verify },
          { path: "reset-mpin", name: 'ResetMpin', component: ResetMpin },
          { path: "reset-success", name: 'ResetSuccess', component: ResetSuccess }
        ]
      },
    ]
  },
  { path: '*', name: 'NotFound', component: NotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
